import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS  } from '@angular/material';
import { DatePipe } from "@angular/common";
import { MessagesGeneral, MessagesTitles, MessagesStatus } from '../../../models/messages';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { FormControl,FormGroup } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

import * as XLSX from 'xlsx';
import * as moment from 'moment';
import Swal from "sweetalert2";
import { FiltrosMarketing2 } from 'app/models/FiltrosMarketing2';
import { ReportesService } from 'app/services/reportes/reportes.service';
import { environment } from 'environments/environment';



export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

@Component({
  selector: 'app-listado-rep-marketing',
  templateUrl: './listado-rep-marketing.component.html',
  styleUrls: ['./listado-rep-marketing.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesStatus,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoRepMarketingComponent implements OnInit {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('TABLE', { static: true }) table: ElementRef;
  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns = ['Fecha_real_desembolso','Num_Doc_Identificacion','Razon_Social','Tipo_Documento_Identidad','Nro_Documento_Identidad','Nombre_de_Contacto','Direccion_Fiscal','Correo','NroMovil_Laboral'];
  today = moment();
  loading: boolean;
  loadingUser: boolean;
  dataReporte: any = [];
  dataSource: any;
  rucAdq = new FormControl();
  fechaD: Date = new Date();
  fechaH: Date = new Date();
  filterValues = {
    Razon_Social:'',
    
    }; 
  dataFiltro : FormGroup;
  DTOFiltrosRepMarketing:FiltrosMarketing2 = new FiltrosMarketing2();
  constructor(private msgTitulos: MessagesTitles,
    private datePipe: DatePipe,
    private msgStatus: MessagesStatus,private reporteService:ReportesService) { 
      this.DTOFiltrosRepMarketing.FechaIni = this.datePipe.transform(moment().add(-30, 'day'),'yyyy-MM-dd');
    this.DTOFiltrosRepMarketing.FechaFin = this.datePipe.transform(moment(),'yyyy-MM-dd');
    }

  ngOnInit() {
    this.listadoReporteMarketing();
    this.rucAdq.valueChanges
    .subscribe(
      Razon_Social => {
        this.filterValues.Razon_Social = Razon_Social;
        this.dataSource.filter = JSON.stringify(this.filterValues);
      }
    );
  }

  ExportTOExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataReporte);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let fecha = new Date();
    XLSX.writeFile(wb, 'Reporte_Marketing' + fecha + '.xlsx');
  }

  createFilter(): (data: any, filter: string) => boolean {
    return function(data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return  data.Razon_Social.toString().toLowerCase().indexOf(searchTerms.Razon_Social) !== -1
      
    }
  }

  listadoReporteMarketing(){
    this.loading = true;
    this.DTOFiltrosRepMarketing.FechaIni = this.datePipe.transform(this.DTOFiltrosRepMarketing.FechaIni,'yyyy-MM-dd')
    this.DTOFiltrosRepMarketing.FechaFin = this.datePipe.transform(this.DTOFiltrosRepMarketing.FechaFin,'yyyy-MM-dd')
    this.reporteService.ObtenerReporteMarketing2(this.DTOFiltrosRepMarketing).subscribe(
      res => {
        this.dataReporte = res;
        this.dataSource = new MatTableDataSource(this.dataReporte);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.dataSource.filterPredicate = this.createFilter();
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error("Error Event");
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA REPORTE NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      }
      
    )
  }

}